import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    position: 'fixed',
  },
}));

export default useStyles;